export default function UnionIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        display: "inline",
      }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 2.2C6 2.08954 6.08954 2 6.2 2H7.8C7.91046 2 8 2.08954 8 2.2V4H12V2.2C12 2.08954 12.0895 2 12.2 2H13.8C13.9105 2 14 2.08954 14 2.2V4H15C15.5523 4 16 4.44772 16 5V13.5H13C12.1716 13.5 11.5 14.1716 11.5 15V18H5C4.44772 18 4 17.5523 4 17V5C4 4.44772 4.44772 4 5 4H6V2.2ZM12.5 17.5V15C12.5 14.7239 12.7239 14.5 13 14.5H15.5L12.5 17.5Z"
        fill="#102A47"
      />
    </svg>
  );
}
